import NewsPage from '@/components/pages/news-archive/NewsArchiveController';
import getStaticProps from '@/components/pages/news-archive/NewsArchiveStaticProps';

export default NewsPage;
export { getStaticProps };
